<div [ngClass]="{'expanded': open | async, 'component': true}"
     data-automation-e2e-selector="marketDrawer">
    <div [ngClass]="{'expanded': open | async, 'marketDrawer': true}">
        <muni-gameday-market-drawer-header></muni-gameday-market-drawer-header>
        <muni-gameday-market-drawer-body></muni-gameday-market-drawer-body>
    </div>
</div>